import { useState } from "react";
import { FaBars } from "react-icons/fa";
import { useSelector } from "react-redux";
import { FaChevronRight, FaRegGrinStars, FaHandHoldingUsd } from "react-icons/fa";
import { FaSackDollar } from "react-icons/fa6";
import { PiNotepadFill } from "react-icons/pi";
import { MdBlock, MdLogout } from "react-icons/md";
import { HiOutlineClipboardDocumentCheck } from "react-icons/hi2";
import { LuMessageCircleHeart } from "react-icons/lu";
import { LogoutUser } from "../services/Firebase";
import { useNavigate } from "react-router-dom";
import { getMediaUrl, getProfileImage } from "../utils/helpers";
import { LogOut } from "../services/api";

function MenuDrawer({ isOpen, onClose, onOpenLogin, onOpenSignUp }) {

    const user = useSelector((state) => state.auth.user);
    const navigate = useNavigate();

    const [showToast, setShowToast] = useState(false);

    const copyId = (id) => {
        navigator.clipboard.writeText(id);

        setShowToast(true);
        setTimeout(() => setShowToast(false), 1200);
    };

    const OnProfileClicked = () => {
        onClose();
        navigate("/myProfile");
    };

    const OnAddCashClicked = () => {
        onClose();
        navigate("/payment");
    };

    const OnBlockedUsersClicked = () => {
        onClose();
        navigate("/blockedUsers");
    };

    const OnRatingClicked = () => {
        onClose();
        navigate("/rating");
    };

    const OnBecomeHostClicked = () => {
        onClose();
        navigate("/becomeHost");
    };

    const OnEarningClicked = () => {
        onClose();
        navigate("/earnings");
    };

    const OnWithdrawClicked = () => {
        onClose();
        navigate("/withdraw");
    };

    const OnWelcomeMessageClicked = () => {
        onClose();
        navigate("/welcomeMessage");
    };

    const OnLogoutClicked = async () => {
        try {
            await LogOut();
            LogoutUser();
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            {/* BACKDROP */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-40"
                    onClick={onClose}
                />
            )}

            {/* DRAWER */}
            <div
                className={`
                    fixed top-0 left-0 h-screen w-72 bg-black text-white z-50
                    transform transition-transform duration-300
                    ${isOpen ? "translate-x-0" : "-translate-x-full"}
                    overflow-hidden
                `}
            >
                <div className="flex items-center gap-4 mt-2 px-4">
                    <button onClick={onClose} className="text-2xl">
                        <FaBars />
                    </button>

                    {/* LOGO + TEXT (separate click) */}
                    <button onClick={onClose} className="flex items-center gap-1">
                        <img src="./images/logo.png" alt="Logo" className="h-10 w-auto" />
                        <span className="text-3xl font-extrabold text-red-500">RED</span>
                    </button>
                </div>

                {/* LOGIN + SIGNUP BUTTONS */}
                {!user ? (
                    <>
                        <div className="mt-12 flex flex-col gap-4 items-center px-4">
                            <button
                                onClick={onOpenLogin}
                                className="w-full max-w-[220px] px-4 py-2 border border-white rounded-full hover:bg-white hover:text-black transition"
                            >
                                Log In
                            </button>

                            <button
                                onClick={onOpenSignUp}
                                className="w-full max-w-[220px] px-4 py-2 bg-red-500 rounded-full"
                            >
                                Sign Up
                            </button>

                        </div>


                        <div className="absolute bottom-4 left-0 w-full text-center text-xs text-gray-400">
                            <a href="/privacy" className="hover:underline">
                                Privacy Policy
                            </a>{" "}
                            |{" "}
                            <a href="/terms" className="hover:underline">
                                Terms Of Use
                            </a>
                        </div>
                    </>
                ) : (
                    <div className="mt-6 px-3 h-[calc(100vh-80px)] overflow-y-auto overflow-x-hidden scroll-smooth pr-1">
                        <button
                            onClick={OnProfileClicked}
                            className="flex items-center w-[230px] bg-black/40 backdrop-blur-md 
                        border border-white/20 rounded-full px-3 py-3 hover:bg-white/10 transition"
                        >
                            <img
                                src={getProfileImage(getMediaUrl(user.ppImageURL))}
                                alt="profile"
                                className="w-8 h-8 rounded-full object-cover"
                                referrerPolicy="no-referrer"
                            />

                            <span className="ml-3 text-white font-semibold text-sm">
                                {user.name}
                            </span>

                            <FaChevronRight className="ml-auto text-white text-lg" />
                        </button>

                        {
                            user?.role === "user" && user?.gender === 1 &&
                            <button
                                onClick={OnAddCashClicked}
                                className="
                            mt-4 w-[230px] h-[48px]
                            flex items-center justify-between
                            bg-gradient-to-r from-black/50 to-black/20
                            border border-white/20 rounded-full
                            px-4 hover:bg-white/10 transition
                        "
                            >
                                <div className="flex items-center gap-2">
                                    <img src="./images/goldcoin.png" alt="coin" className="w-8 h-8 rounded-full object-cover" />
                                    <span className="text-white font-semibold text-sm">
                                        {user?.walletBalance?.toFixed(2)}
                                    </span>
                                </div>

                                <div className="flex items-center gap-2">
                                    <span className="text-yellow-400 font-medium text-[12px]">
                                        Get more coins
                                    </span>
                                    <FaChevronRight className="text-yellow-400 text-sm" />
                                </div>
                            </button>
                        }

                        <button
                            onClick={() => copyId(user.unique_id)}
                            className="
                            mt-4 w-[230px] h-[48px]
                            flex items-center justify-between
                            bg-gradient-to-r from-black/50 to-black/20
                            border border-white/20 rounded-full
                            px-4 hover:bg-white/10 transition
                        "
                        >
                            <div className="flex items-center gap-2">
                                <PiNotepadFill className="text-yellow-400 text-2xl" />
                                <span className="text-yellow-400 font-semibold text-sm">
                                    Unique Id: {user.unique_id}
                                </span>
                            </div>

                            <div className="flex items-center gap-2">
                                <FaChevronRight className="text-yellow-400 text-sm" />
                            </div>
                        </button>

                        <button
                            onClick={OnBlockedUsersClicked}
                            className="
                            mt-4 w-[230px] h-[48px]
                            flex items-center justify-between
                            bg-gradient-to-r from-black/50 to-black/20
                            border border-white/20 rounded-full
                            px-4 hover:bg-white/10 transition
                        "
                        >
                            <div className="flex items-center gap-2">
                                <MdBlock className="text-white-400 text-2xl" />
                                <span className="text-white-400 font-semibold text-sm">
                                    Blocked Users
                                </span>
                            </div>

                            <div className="flex items-center gap-2">
                                <FaChevronRight className="text-white-400 text-sm" />
                            </div>
                        </button>

                        {
                            user?.role === "host" &&
                            <button
                                onClick={OnRatingClicked}
                                className="
                            mt-4 w-[230px] h-[48px]
                            flex items-center justify-between
                            bg-gradient-to-r from-black/50 to-black/20
                            border border-white/20 rounded-full
                            px-4 hover:bg-white/10 transition
                        "
                            >
                                <div className="flex items-center gap-2">
                                    <FaRegGrinStars className="text-white-400 text-2xl" />
                                    <span className="text-white-400 font-semibold text-sm">
                                        Rating Calculator
                                    </span>
                                </div>

                                <div className="flex items-center gap-2">
                                    <FaChevronRight className="text-white-400 text-sm" />
                                </div>
                            </button>
                        }

                        {
                            user?.role === "user" && user?.gender === 2 &&
                            <button
                                onClick={OnBecomeHostClicked}
                                className="
                            mt-4 w-[230px] h-[48px]
                            flex items-center justify-between
                            bg-gradient-to-r from-black/50 to-black/20
                            border border-white/20 rounded-full
                            px-4 hover:bg-white/10 transition
                        "
                            >
                                <div className="flex items-center gap-2">
                                    <HiOutlineClipboardDocumentCheck className="text-white-400 text-2xl" />
                                    <span className="text-white-400 font-semibold text-sm">
                                        Become A Host
                                    </span>
                                </div>

                                <div className="flex items-center gap-2">
                                    <FaChevronRight className="text-white-400 text-sm" />
                                </div>
                            </button>
                        }

                        {
                            user?.role === "host" &&
                            <button
                                onClick={OnEarningClicked}
                                className="
                            mt-4 w-[230px] h-[48px]
                            flex items-center justify-between
                            bg-gradient-to-r from-black/50 to-black/20
                            border border-white/20 rounded-full
                            px-4 hover:bg-white/10 transition
                        "
                            >
                                <div className="flex items-center gap-2">
                                    <FaSackDollar className="text-white-400 text-2xl" />
                                    <span className="text-white-400 font-semibold text-sm">
                                        Earning and Statistics
                                    </span>
                                </div>

                                <div className="flex items-center gap-2">
                                    <FaChevronRight className="text-white-400 text-sm" />
                                </div>
                            </button>
                        }

                        {
                            user?.role === "host" &&
                            <button
                                onClick={OnWithdrawClicked}
                                className="
                            mt-4 w-[230px] h-[48px]
                            flex items-center justify-between
                            bg-gradient-to-r from-black/50 to-black/20
                            border border-white/20 rounded-full
                            px-4 hover:bg-white/10 transition
                        "
                            >
                                <div className="flex items-center gap-2">
                                    <FaHandHoldingUsd className="text-white-400 text-2xl" />
                                    <span className="text-white-400 font-semibold text-sm">
                                        Withdraw
                                    </span>
                                </div>

                                <div className="flex items-center gap-2">
                                    <FaChevronRight className="text-white-400 text-sm" />
                                </div>
                            </button>
                        }

                        {
                            user?.role === "host" &&
                            <button
                                onClick={OnWelcomeMessageClicked}
                                className="
                                    mt-4 w-[230px] h-[48px]
                                    flex items-center justify-between
                                    bg-gradient-to-r from-black/50 to-black/20
                                    border border-white/20 rounded-full
                                    px-4 hover:bg-white/10 transition
                                "
                            >
                                <div className="flex items-center gap-2">
                                    <LuMessageCircleHeart className="text-white-400 text-2xl" />
                                    <span className="text-white-400 font-semibold text-sm">
                                        Welcome Message
                                    </span>
                                </div>

                                <div className="flex items-center gap-2">
                                    <FaChevronRight className="text-white-400 text-sm" />
                                </div>
                            </button>
                        }

                        <button
                            onClick={OnLogoutClicked}
                            className="
                            mt-4 w-[230px] h-[48px]
                            flex items-center justify-between
                            bg-gradient-to-r from-black/50 to-black/20
                            border border-white/20 rounded-full
                            px-4 hover:bg-white/10 transition
                        "
                        >
                            <div className="flex items-center gap-2">
                                <MdLogout className="text-white-400 text-2xl" />
                                <span className="text-white-400 font-semibold text-sm">
                                    Log Out
                                </span>
                            </div>
                        </button>

                        <div className="text-center text-xs text-gray-400 mt-6">
                            <a href="/privacy" className="hover:underline">
                                Privacy Policy
                            </a>{" "}
                            |{" "}
                            <a href="/terms" className="hover:underline">
                                Terms Of Use
                            </a>
                        </div>

                        {showToast && (
                            <div
                                className="
                                    fixed inset-0 flex items-center justify-center
                                    z-50
                                "
                            >
                                <div
                                    className="
                                    bg-black/80 text-white px-6 py-3
                                    rounded-full text-sm
                                    animate-fade
                                    "
                                >
                                    ID Copied
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </>
    );
}

export default MenuDrawer;
